import { render, staticRenderFns } from "./ReturnabilityDashboard.vue?vue&type=template&id=e0756a6e&scoped=true"
import script from "./ReturnabilityDashboard.vue?vue&type=script&lang=js"
export * from "./ReturnabilityDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReturnabilityDashboard.vue?vue&type=style&index=0&id=e0756a6e&prod&lang=sass&scoped=true"
import style1 from "./ReturnabilityDashboard.vue?vue&type=style&index=1&id=e0756a6e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0756a6e",
  null
  
)

export default component.exports